import type {
  GridFilterModel,
  GridValidRowModel,
} from "@mui/x-data-grid-premium";
import type { GridColDef } from "src/components/DataGrid/DataGrid.tsx";

export const prepareFilterModel = <
  Row extends GridValidRowModel = GridValidRowModel,
>(
  filterModel: GridFilterModel,
  columns: GridColDef<Row>[],
) => {
  return {
    ...filterModel,
    items: (filterModel?.items || []).map((item) => {
      const column = columns.find((column) => item.field === column.field);
      const getValue = () => {
        if (column?.type === "number") {
          if (typeof item.value === "string" && item.value.includes("bis")) {
            const range = item.value.split("bis");
            return range.map((value) => +value.trim());
          }
          if (typeof item.value === "string" && item.value.includes("to")) {
            const range = item.value.split("to");
            return range.map((value) => +value.trim());
          }
          return item.value;
        }
        if (column?.type === "multiSelect") {
          return item.value?.join(",");
        }
        return item.value;
      };
      return {
        ...item,
        value: getValue(),
        field: column?.backendFilterName || item.field,
      };
    }),
  };
};
